import { Controller } from "@hotwired/stimulus"

// apriScheda(k) di pages/Rendicontazione.js (onApri dei pulsanti di Erogazione: «Vai alle fatture», «Apri la fattura»…):
// apre la scheda della Rendicontazione premendo il suo pulsante, cosi' lo fa tabs_controller.js (mostra il pannello e
// scrive ?scheda= con replaceState).
//   <button data-controller="vai-scheda" data-action="vai-scheda#vai" data-vai-scheda-scheda-param="fatture">
export default class extends Controller {
  vai(event) {
    const scheda = event.params.scheda
    if (!scheda) return
    document.querySelector(`[role='tab'][data-testid='scheda-${CSS.escape(scheda)}']`)?.click()
  }
}
